import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../../utils/ModalEventListener";

const AmountMismatchModal = ({
  closeAmountMismatchModal,
  mismatchBtnClickFunc,
}) => {
  const ref = useRef();
  useEffect(() => {
    return modalEventListener(ref, closeAmountMismatchModal);
  }, [closeAmountMismatchModal]);

  const handleMismatchBtnClick = (e) => {
    mismatchBtnClickFunc();
    e.stopPropagation();
  };
  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <div className="amount-mismatch-modal-content" ref={ref}>
        <div className="modal-header" style={{ height: "100px" }}>
          <button
            type="button"
            className="close"
            onClick={closeAmountMismatchModal}
          >
            <span>×</span>
          </button>
          <h4 className="modal-title" id="myModalLabel2">
            Would you like to proceed?
          </h4>
        </div>
        <div className="modal-body">
          <div className="text-center">
            <img
              src={`${process.env.REACT_APP_STYLES_PATH}warning-icon.png`}
              alt="warning"
            />
            <br />
            <br />
            <p style={{ color: "red" }}>
              Alert! You are releasing Amount above Net Disbursement Amount.
              Please ensure you are releasing the correct amount
            </p>
          </div>
        </div>
        <div className="modal-footer justify-content-center">
          <button
            id="mismatch_amt_btn"
            className="btn btn-danger"
            onClick={(e) => handleMismatchBtnClick(e)}
          >
            Continue <i className="far fa-gem ml-1 text-white"></i>
          </button>
          <button
            className="btn rc-btn_rset pad-L20 pad-R20"
            onClick={closeAmountMismatchModal}
          >
            No, thanks
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default AmountMismatchModal;
